module.exports = __webpack_public_path__ + "static/media/pino_helsinki.994c75bc.jpg";